<template lang="html">
  <scroll class="home"
    :listenScroll="listenScroll"
    :probe-type="scrollProbeType"
    ref="home">
    <div>
      <div class="top">
        <img v-lazy="home.bannerData.imgRul" alt="" class="move">
        <div class="content">
          <h2>{{home.bannerData.name}}</h2>
          <h1>{{home.bannerData.tip}}<span>{{`"${home.bannerData.intro}"`}}</span></h1>
          <p>{{home.bannerData.content}}</p>
          <button type="button" name="button" @click="toAboutUs(home.bannerData.link)">了解更多</button>
        </div>
      </div>
      <div class="mid">
        <div class="mid-t">
          <h2>最新产品</h2>
          <div class="">
            <div class="more" @click="toProduce(newProduce.moreLink)">
              更多产品
              <i class="icon iconfont icon-gengduo1"></i>
            </div>
          </div>
        </div>
        <div class="mid-content">
          <slide class="nav"
            :probe-type="slideProbeType"
            :scrollX="slideXFlag"
            :scrollY="slideYFlag"
            :data="newProduce.contentList"
            ref="navWrapper">
            <ul class="nav-box" ref="navBox">
              <li v-for="(item, index) in newProduce.contentList" :key="index">
                <div class="more-pd">
                  <img v-lazy="item.imgUrl" alt="" class="move">
                  <button type="button" name="button" @click="toDowload(item)">立即下载</button>
                </div>
              </li>
            </ul>
          </slide>
        </div>
      </div>
      <div class="bom">
        <div class="" v-for="(item, index) in homeIntro" :key="index">
          <div class="">
            <p v-for="(inItem, inIndex) in item.content" :key="inIndex">{{inItem.txt}}<span v-if="inItem.lig">{{inItem.lig}}</span></p>
          </div>
          <div class="">
            <img v-lazy="item.imgUrl" alt="">
          </div>
        </div>
      </div>
      <div class="mid customer">
        <div class="mid-t">
          <h2>客户信息</h2>
        </div>
        <div class="mid-content">
          <slide class="nav-se"
            :probe-type="slideProbeType"
            :scrollX="slideXFlag"
            :scrollY="slideYFlag"
            :data="customerInfo"
            ref="navWrapperSe">
            <ul class="nav-box" ref="navBoxSe">
              <li v-for="(item, index) in customerInfo" :key="index">
                <div class="co-info">
                  <img v-lazy="item.imgUrl" alt="">
                  <div class="name">
                    <div class="">
                      <h2>{{item.local}}</h2>
                      <h1>{{item.name}}</h1>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </slide>
        </div>
      </div>
      <m-footer></m-footer>
    </div>
  </scroll>
</template>

<script>
import Slide from 'base/slide/slide'
import Scroll from 'base/scroll/scroll'
import MFooter from 'components/ter/footer/footer'
import homeData from 'common/ter/js/home'
export default {
  created () {
    this.slideProbeType = 3
    this.scrollProbeType = 2
    this.home = homeData
    this.newProduce = homeData.newProduce
    this.homeIntro = homeData.homeIntro
    this.customerInfo = homeData.customerInfo
  },
  mounted () {
    this.$nextTick(() => {
      // 导航初始化
      this._initNav()
    })
  },
  data () {
    return {
      slideXFlag: true,
      slideYFlag: false,
      listenScroll: true,
      home: null,
      newProduce: null,
      homeIntro: null,
      customerInfo: null
    }
  },
  methods: {
    toDowload (item) {
      console.log(item)
      if (item.targetBlank) {
        window.open(item.imgLink)
      } else {
        this.$router.push({
          path: item.imgLink
        })
      }
    },
    // 更多产品
    toProduce (url) {
      this.$router.push({
        path: url
      })
    },
    // 了解更多
    toAboutUs (url) {
      this.$router.push({
        path: url
      })
    },
    _initNav () {
      // 横向滚动 宽度
      let w = 0
      let ws = 0
      Array.prototype.forEach.call(this.$refs.navBox.children, (v, i) => {
        w += v.clientWidth
      })
      this.$refs.navBox.style.width = `${w + 10}px`
      Array.prototype.forEach.call(this.$refs.navBoxSe.children, (v, i) => {
        ws += v.clientWidth
      })
      this.$refs.navBoxSe.style.width = `${ws + 10}px`
    }
  },
  components: {
    Scroll,
    Slide,
    MFooter
  }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
@import "~common/ter/stylus/media"
.home>div>div
  position: relative
img
  width: 100%
  display: block
.top
  img
    set-height(300)
  .content
    position: absolute
    left: 0
    right: 0
    top: 50%
    transform: translate3d(0, -50%, 0)
    color: #fff
    margin: auto
    padding-left: 40px
button
  overflow: hidden
  color: #007CE5
  cursor: pointer
.content
    h2
      font-size: 21px
    h1
      font-size: 28px
      margin: 5px 0 15px
      span
        font-size: 15px
    p
      margin-bottom: 10px
      font-size: 12px
    button
      width: 90px
      height: 35px
      border-radius: 35px
      margin-top: 40px
  .mid
    padding: 15px 0
  .mid-content
    .nav, .nav-se
      overflow: hidden
    p
      display: none
    ul
      padding-left: 10px
      &:after
        content: ''
        clear: both
    li
      position: relative
      float: left
      padding-right: 15px
      &:last-of-type
        padding-right: 0
      .more-pd
        set-width(270)
        set-height(230)
        position: relative
      .co-info
        set-width(230)
        set-height(170)
      button
        width: 90px
        height: 30px
        position: absolute
        right: 22px
        top: 30px
        font-size: 12px
        border-radius: 30px
        overflow: hidden
      img
        width: 100%
        height: 100%
  .mid-t
    display: flex
    justify-content: space-between
    align-items: flex-end
    padding: 10px 10px 6px 18px
    h2
      position: relative
      font-size: 14px
      color: #007CE5
      &:after
        content: ''
        width: 4px
        height: 10px
        position: absolute
        left: -7px
        top: 2px
        background-color: #007CE5
    .more
      display: flex
      justify-content: space-between
      align-items: center
      font-size: 12px
      color: #333
      line-height: 1
    .iconfont
      margin-left: 5px
      color: #007CE5
      font-size: 8px
    .tip
      display: none
  .customer
    li
      &>div
        width: 230px
      .name
        set-width(230)
        set-height(40)
        position: absolute
        left: 0
        bottom: 0
        background-color: rgba(0, 175, 255, 0.7)
        color: #fff
        h1
          font-size: 18px
        h2
          margin-right: 10px
          font-size: 12px
        div
          width: 100%
          height: 100%
          display: flex
          align-items: flex-end
          padding: 7px
          line-height: 1
  .bom
    img
      set-width(180)
      set-height(180)
    &>div
      display: flex
      justify-content: space-between
      padding: 0 10px 16px 10px
      &>div
        flex: 1
        text-align: center
        display: flex
        justify-content: center
        flex-direction: column
        background-color: #F8F8F8
        font-size: 17px
      span
        color: #007CE5
    &>div:nth-of-type(2)
      flex-direction: row-reverse
</style>



// WEBPACK FOOTER //
// src/components/ter/home/home.vue